export const EAppTableMod = {
  links: 'links'
}
